/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/pickuppointfee/edit/pickup-point-fee-edit.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../../public/upgrade/feature/pickuppointfee/pickup-point-fee.service';
import * as import6 from '../../../../../../public/upgrade/shared/sara-selector/sara-selector.service';
import * as import7 from '../../../../../../public/upgrade/core/point-of-sale.service.service';
import * as import8 from '../../../../../../public/upgrade/core/additional-pickup-point.service';
import * as import9 from '@angular/core/src/linker/view_type';
import * as import10 from '@angular/core/src/change_detection/constants';
import * as import11 from '@angular/core/src/linker/component_factory';
import * as import12 from '@angular/http/src/http';
import * as import13 from '@ngx-translate/core/src/translate.service';
import * as import14 from '@angular/core/src/zone/ng_zone';
import * as import15 from '@angular/router/src/router_state';
import * as import16 from '../../../../../../public/upgrade/root/toast/notification.service';
import * as import17 from '@angular/router/src/router';
import * as import18 from '../../../../../../public/upgrade/root/modal/modal.service';
import * as import19 from '../../../../../../public/upgrade/root/loading/loading-wheel.service';
import * as import20 from '@angular/forms/src/form_builder';
import * as import21 from '../../../../../../public/upgrade/core/session.service';
import * as import22 from '../../../../../../public/upgrade/root/sidebar/sidebar.service';
import * as import23 from '../../../../../../public/upgrade/shared/sara-radio/sara-radio.component';
import * as import24 from '../../../shared/sara-radio/sara-radio.component.ngfactory';
import * as import25 from '@angular/core/src/linker/view_container';
import * as import26 from '@ngx-translate/core/src/translate.pipe';
import * as import27 from '@angular/core/src/change_detection/change_detection_util';
import * as import28 from '../../../../../../public/upgrade/shared/eva-button/eva-button.component';
import * as import29 from '../../../shared/eva-button/eva-button.component.ngfactory';
import * as import30 from '../../../../../../public/upgrade/shared/sara-input/sara-input-a2.component';
import * as import31 from '../../../shared/sara-input/sara-input-a2.component.ngfactory';
import * as import32 from '../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import33 from '@angular/core/src/linker/template_ref';
import * as import34 from '@angular/forms/src/directives/control_value_accessor';
import * as import35 from '@angular/common/src/directives/ng_if';
import * as import36 from '@angular/core/src/linker/query_list';
import * as import37 from '../../../../../node_modules/@angular/forms/src/directives/ng_form.ngfactory';
import * as import38 from '../../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import39 from '../../../../../../public/upgrade/shared/card/form-card.component';
import * as import40 from '../../../shared/card/form-card.component.ngfactory';
import * as import41 from '../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import42 from '../../../../../../public/upgrade/shared/sara-select/sara-select.component';
import * as import43 from '../../../shared/sara-select/sara-select.component.ngfactory';
import * as import44 from '../../../../../../public/upgrade/shared/sara-selector/sara-selector.component';
import * as import45 from '../../../shared/sara-selector/sara-selector.component.ngfactory';
import * as import46 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import47 from '@angular/common/src/directives/ng_for';
import * as import48 from '@angular/forms/src/directives/ng_form';
import * as import49 from '@angular/forms/src/directives/control_container';
import * as import50 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_PickupPointFeeEditComponent {
  /*private*/ _eventHandler:Function;
  context:import0.PickupPointFeeEditComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any,p10:any,p11:any,p12:any,p13:any) {
    this._changed = false;
    this.context = new import0.PickupPointFeeEditComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12,p13);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_PickupPointFeeEditComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_PickupPointFeeEditComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.PickupPointFeeEditComponent>;
  _PickupPointFeeService_0_3:import5.PickupPointFeeService;
  _SaraSelectorService_0_4:import6.SaraSelectorService;
  _PointOfSaleA2Service_0_5:import7.PointOfSaleA2Service;
  _AdditionalPickupPointService_0_6:import8.AdditionalPickupPointService;
  _PickupPointFeeEditComponent_0_7:Wrapper_PickupPointFeeEditComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_PickupPointFeeEditComponent_Host0,renderType_PickupPointFeeEditComponent_Host,import9.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'pickup-point-fee-edit',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_PickupPointFeeEditComponent0(this.viewUtils,this,0,this._el_0);
    this._PickupPointFeeService_0_3 = new import5.PickupPointFeeService(this.injectorGet(import12.Http,this.parentIndex),this.injectorGet(import13.TranslateService,this.parentIndex));
    this._SaraSelectorService_0_4 = new import6.SaraSelectorService();
    this._PointOfSaleA2Service_0_5 = new import7.PointOfSaleA2Service(this.injectorGet(import12.Http,this.parentIndex));
    this._AdditionalPickupPointService_0_6 = new import8.AdditionalPickupPointService(this.injectorGet(import12.Http,this.parentIndex));
    this._PickupPointFeeEditComponent_0_7 = new Wrapper_PickupPointFeeEditComponent(this._PickupPointFeeService_0_3,this._SaraSelectorService_0_4,this.injectorGet(import14.NgZone,this.parentIndex),this._PointOfSaleA2Service_0_5,this._AdditionalPickupPointService_0_6,this.injectorGet(import15.ActivatedRoute,this.parentIndex),this.injectorGet(import16.NotificationService,this.parentIndex),this.injectorGet(import17.Router,this.parentIndex),this.injectorGet(import18.ModalService,this.parentIndex),this.injectorGet(import19.LoadingWheelService,this.parentIndex),this.injectorGet(import20.FormBuilder,this.parentIndex),this.injectorGet(import21.SessionService,this.parentIndex),this.injectorGet(import22.SidebarService,this.parentIndex),this.injectorGet(import13.TranslateService,this.parentIndex));
    this.compView_0.create(this._PickupPointFeeEditComponent_0_7.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import11.ComponentRef_<any>(0,this,this._el_0,this._PickupPointFeeEditComponent_0_7.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.PickupPointFeeService) && (0 === requestNodeIndex))) { return this._PickupPointFeeService_0_3; }
    if (((token === import6.SaraSelectorService) && (0 === requestNodeIndex))) { return this._SaraSelectorService_0_4; }
    if (((token === import7.PointOfSaleA2Service) && (0 === requestNodeIndex))) { return this._PointOfSaleA2Service_0_5; }
    if (((token === import8.AdditionalPickupPointService) && (0 === requestNodeIndex))) { return this._AdditionalPickupPointService_0_6; }
    if (((token === import0.PickupPointFeeEditComponent) && (0 === requestNodeIndex))) { return this._PickupPointFeeEditComponent_0_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._PickupPointFeeEditComponent_0_7.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const PickupPointFeeEditComponentNgFactory:import11.ComponentFactory<import0.PickupPointFeeEditComponent> = new import11.ComponentFactory<import0.PickupPointFeeEditComponent>('pickup-point-fee-edit',View_PickupPointFeeEditComponent_Host0,import0.PickupPointFeeEditComponent);
const styles_PickupPointFeeEditComponent:any[] = ([] as any[]);
class View_PickupPointFeeEditComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import23.SaraRadioComponent>;
  _SaraRadioComponent_2_3:import24.Wrapper_SaraRadioComponent;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import25.ViewContainer) {
    super(View_PickupPointFeeEditComponent1,renderType_PickupPointFeeEditComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-md-4 -sm-12'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'sara-radio',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import24.View_SaraRadioComponent0(this.viewUtils,this,2,this._el_2);
    this._SaraRadioComponent_2_3 = new import24.Wrapper_SaraRadioComponent();
    this._text_3 = this.renderer.createText((null as any),'\n                                                ',(null as any));
    this.compView_2.create(this._SaraRadioComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this._SaraRadioComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),false,true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.SaraRadioComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._SaraRadioComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = 'feeCategory';
    this._SaraRadioComponent_2_3.check_name(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this.context.$implicit;
    this._SaraRadioComponent_2_3.check_item(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = this.parentView.context.fee.category;
    this._SaraRadioComponent_2_3.check_model(currVal_2_0_2,throwOnChange,false);
    this._SaraRadioComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._SaraRadioComponent_2_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.fee.category = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_PickupPointFeeEditComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _text_5:any;
  _el_6:any;
  _el_7:any;
  _text_8:any;
  _text_9:any;
  /*private*/ _expr_10:any;
  _pipe_translate_0:import26.TranslatePipe;
  /*private*/ _expr_12:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import25.ViewContainer) {
    super(View_PickupPointFeeEditComponent2,renderType_PickupPointFeeEditComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_10 = import27.UNINITIALIZED;
    this._expr_12 = import27.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -md-4 -sm-12'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,' ',(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,this._el_0,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'',(null as any));
    this._text_5 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_0,'br',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','-eva-3-mt-sm'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'',(null as any));
    this._text_9 = this.renderer.createText(this._el_0,' \n                                        ',(null as any));
    this._pipe_translate_0 = new import26.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._text_5,
      this._el_6,
      this._el_7,
      this._text_8,
      this._text_9
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import27.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_10:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('fees.FEEIDENTIFIER.priorName')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_10,currVal_10))) {
      this.renderer.setText(this._text_4,currVal_10);
      this._expr_10 = currVal_10;
    }
    const currVal_12:any = import3.inlineInterpolate(1,'',this.parentView.context.fee.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_12,currVal_12)) {
      this.renderer.setText(this._text_8,currVal_12);
      this._expr_12 = currVal_12;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_PickupPointFeeEditComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  /*private*/ _expr_14:any;
  _pipe_translate_0:import26.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import25.ViewContainer) {
    super(View_PickupPointFeeEditComponent3,renderType_PickupPointFeeEditComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_14 = import27.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-md-12 -sm-12 -eva-3-pt-md -eva-3-pb-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','col -md-12 -sm-12'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'a',new import3.InlineArray2(2,'class','eva-3-btn -sm -secondary -eva-3-fr'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                                                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'em',new import3.InlineArray2(2,'class','btn-text'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_6,'\n                                            ',(null as any));
    this._text_11 = this.renderer.createText(this._el_4,'\n                                        ',(null as any));
    this._text_12 = this.renderer.createText(this._el_2,'\n                                    ',(null as any));
    this._text_13 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_6,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_6));
    this._pipe_translate_0 = new import26.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._text_13
    ]
    ),[disposable_0]);
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import27.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_14:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform((!!this.parentView.context.showCreateFeeIdentifier? 'fees.FEEIDENTIFIER.hideCreate': 'fees.FEEIDENTIFIER.showCreate'))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_14,currVal_14))) {
      this.renderer.setText(this._text_9,currVal_14);
      this._expr_14 = currVal_14;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_6(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.showCreateFeeIdentifier = !this.parentView.context.showCreateFeeIdentifier)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_PickupPointFeeEditComponent5 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import28.EvaButtonComponent>;
  _EvaButtonComponent_0_3:import29.Wrapper_EvaButtonComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import25.ViewContainer) {
    super(View_PickupPointFeeEditComponent5,renderType_PickupPointFeeEditComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'eva-button',new import3.InlineArray2(2,'class','-eva-3-fr'),(null as any));
    this.compView_0 = new import29.View_EvaButtonComponent0(this.viewUtils,this,0,this._el_0);
    this._EvaButtonComponent_0_3 = new import29.Wrapper_EvaButtonComponent();
    this.compView_0.create(this._EvaButtonComponent_0_3.context);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'action',(null as any)),this.eventHandler(this.handleEvent_0));
    this._EvaButtonComponent_0_3.subscribe(this,this.eventHandler(this.handleEvent_0),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import28.EvaButtonComponent) && (0 === requestNodeIndex))) { return this._EvaButtonComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.parentView.parentView.context.createFeeIdentifiersButton;
    this._EvaButtonComponent_0_3.check_button(currVal_0_0_0,throwOnChange,false);
    this._EvaButtonComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._EvaButtonComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'action')) {
      const pd_sub_0:any = ((<any>this.parentView.parentView.context.createFeeIdentifiers()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_PickupPointFeeEditComponent6 extends import1.AppView<any> {
  _el_0:any;
  _el_1:any;
  _text_2:any;
  /*private*/ _expr_3:any;
  _pipe_translate_0:import26.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import25.ViewContainer) {
    super(View_PickupPointFeeEditComponent6,renderType_PickupPointFeeEditComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_3 = import27.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'a',new import3.InlineArray2(2,'class','eva-3-btn -md -primary -eva-3-fr'),(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,this._el_0,'em',new import3.InlineArray2(2,'class','btn-text'),(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'',(null as any));
    this._pipe_translate_0 = new import26.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._el_1,
      this._text_2
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import27.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_3:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('common.LOADING')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_3,currVal_3))) {
      this.renderer.setText(this._text_2,currVal_3);
      this._expr_3 = currVal_3;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_PickupPointFeeEditComponent4 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  compView_8:import1.AppView<import30.SaraInputA2Component>;
  _SaraInputA2Component_8_3:import31.Wrapper_SaraInputA2Component;
  __NG_VALUE_ACCESSOR_8_4:any[];
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  compView_14:import1.AppView<import30.SaraInputA2Component>;
  _SaraInputA2Component_14_3:import31.Wrapper_SaraInputA2Component;
  __NG_VALUE_ACCESSOR_14_4:any[];
  _text_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  compView_20:import1.AppView<import30.SaraInputA2Component>;
  _SaraInputA2Component_20_3:import31.Wrapper_SaraInputA2Component;
  __NG_VALUE_ACCESSOR_20_4:any[];
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _el_27:any;
  _text_28:any;
  _anchor_29:any;
  /*private*/ _vc_29:import25.ViewContainer;
  _TemplateRef_29_5:any;
  _NgIf_29_6:import32.Wrapper_NgIf;
  _text_30:any;
  _anchor_31:any;
  /*private*/ _vc_31:import25.ViewContainer;
  _TemplateRef_31_5:any;
  _NgIf_31_6:import32.Wrapper_NgIf;
  _text_32:any;
  _text_33:any;
  _text_34:any;
  _el_35:any;
  _text_36:any;
  _map_52:any;
  _map_53:any;
  _map_54:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import25.ViewContainer) {
    super(View_PickupPointFeeEditComponent4,renderType_PickupPointFeeEditComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_52 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        name: p0,
        placeholder: p1
      }
      ;
    });
    this._map_53 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        name: p0,
        placeholder: p1
      }
      ;
    });
    this._map_54 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        name: p0,
        placeholder: p1
      }
      ;
    });
  }
  get _NG_VALUE_ACCESSOR_8_4():any[] {
    if ((this.__NG_VALUE_ACCESSOR_8_4 == null)) { (this.__NG_VALUE_ACCESSOR_8_4 = [this._SaraInputA2Component_8_3.context]); }
    return this.__NG_VALUE_ACCESSOR_8_4;
  }
  get _NG_VALUE_ACCESSOR_14_4():any[] {
    if ((this.__NG_VALUE_ACCESSOR_14_4 == null)) { (this.__NG_VALUE_ACCESSOR_14_4 = [this._SaraInputA2Component_14_3.context]); }
    return this.__NG_VALUE_ACCESSOR_14_4;
  }
  get _NG_VALUE_ACCESSOR_20_4():any[] {
    if ((this.__NG_VALUE_ACCESSOR_20_4 == null)) { (this.__NG_VALUE_ACCESSOR_20_4 = [this._SaraInputA2Component_20_3.context]); }
    return this.__NG_VALUE_ACCESSOR_20_4;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-md-12 -sm-12'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'hr',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','col -md-4 -sm-12'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                                            ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'sara-input-a2',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_8 = new import31.View_SaraInputA2Component0(this.viewUtils,this,8,this._el_8);
    this._SaraInputA2Component_8_3 = new import31.Wrapper_SaraInputA2Component();
    this._text_9 = this.renderer.createText((null as any),'\n                                            ',(null as any));
    this.compView_8.create(this._SaraInputA2Component_8_3.context);
    this._text_10 = this.renderer.createText(this._el_6,'\n                                        ',(null as any));
    this._text_11 = this.renderer.createText(this._el_4,'\n\n                                        ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','col -md-4 -sm-12'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                                            ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_12,'sara-input-a2',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_14 = new import31.View_SaraInputA2Component0(this.viewUtils,this,14,this._el_14);
    this._SaraInputA2Component_14_3 = new import31.Wrapper_SaraInputA2Component();
    this._text_15 = this.renderer.createText((null as any),'\n                                            ',(null as any));
    this.compView_14.create(this._SaraInputA2Component_14_3.context);
    this._text_16 = this.renderer.createText(this._el_12,'\n                                        ',(null as any));
    this._text_17 = this.renderer.createText(this._el_4,'\n\n                                        ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','col -md-4 -sm-12'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n                                            ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_18,'sara-input-a2',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_20 = new import31.View_SaraInputA2Component0(this.viewUtils,this,20,this._el_20);
    this._SaraInputA2Component_20_3 = new import31.Wrapper_SaraInputA2Component();
    this._text_21 = this.renderer.createText((null as any),'\n                                            ',(null as any));
    this.compView_20.create(this._SaraInputA2Component_20_3.context);
    this._text_22 = this.renderer.createText(this._el_18,'\n                                        ',(null as any));
    this._text_23 = this.renderer.createText(this._el_4,'\n                                    ',(null as any));
    this._text_24 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'\n                                        ',(null as any));
    this._el_27 = import3.createRenderElement(this.renderer,this._el_25,'div',new import3.InlineArray2(2,'class','col -md-12 -sm-12'),(null as any));
    this._text_28 = this.renderer.createText(this._el_27,'\n                                            ',(null as any));
    this._anchor_29 = this.renderer.createTemplateAnchor(this._el_27,(null as any));
    this._vc_29 = new import25.ViewContainer(29,27,this,this._anchor_29);
    this._TemplateRef_29_5 = new import33.TemplateRef_(this,29,this._anchor_29);
    this._NgIf_29_6 = new import32.Wrapper_NgIf(this._vc_29.vcRef,this._TemplateRef_29_5);
    this._text_30 = this.renderer.createText(this._el_27,'\n                                            ',(null as any));
    this._anchor_31 = this.renderer.createTemplateAnchor(this._el_27,(null as any));
    this._vc_31 = new import25.ViewContainer(31,27,this,this._anchor_31);
    this._TemplateRef_31_5 = new import33.TemplateRef_(this,31,this._anchor_31);
    this._NgIf_31_6 = new import32.Wrapper_NgIf(this._vc_31.vcRef,this._TemplateRef_31_5);
    this._text_32 = this.renderer.createText(this._el_27,'\n                                        ',(null as any));
    this._text_33 = this.renderer.createText(this._el_25,'\n                                    ',(null as any));
    this._text_34 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_35 = import3.createRenderElement(this.renderer,this._el_0,'hr',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_36 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_8,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_8));
    this._SaraInputA2Component_8_3.subscribe(this,this.eventHandler(this.handleEvent_8),true);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_14,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_14));
    this._SaraInputA2Component_14_3.subscribe(this,this.eventHandler(this.handleEvent_14),true);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_20,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_20));
    this._SaraInputA2Component_20_3.subscribe(this,this.eventHandler(this.handleEvent_20),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._anchor_29,
      this._text_30,
      this._anchor_31,
      this._text_32,
      this._text_33,
      this._text_34,
      this._el_35,
      this._text_36
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import30.SaraInputA2Component) && ((8 <= requestNodeIndex) && (requestNodeIndex <= 9)))) { return this._SaraInputA2Component_8_3.context; }
    if (((token === import34.NG_VALUE_ACCESSOR) && ((8 <= requestNodeIndex) && (requestNodeIndex <= 9)))) { return this._NG_VALUE_ACCESSOR_8_4; }
    if (((token === import30.SaraInputA2Component) && ((14 <= requestNodeIndex) && (requestNodeIndex <= 15)))) { return this._SaraInputA2Component_14_3.context; }
    if (((token === import34.NG_VALUE_ACCESSOR) && ((14 <= requestNodeIndex) && (requestNodeIndex <= 15)))) { return this._NG_VALUE_ACCESSOR_14_4; }
    if (((token === import30.SaraInputA2Component) && ((20 <= requestNodeIndex) && (requestNodeIndex <= 21)))) { return this._SaraInputA2Component_20_3.context; }
    if (((token === import34.NG_VALUE_ACCESSOR) && ((20 <= requestNodeIndex) && (requestNodeIndex <= 21)))) { return this._NG_VALUE_ACCESSOR_20_4; }
    if (((token === import33.TemplateRef) && (29 === requestNodeIndex))) { return this._TemplateRef_29_5; }
    if (((token === import35.NgIf) && (29 === requestNodeIndex))) { return this._NgIf_29_6.context; }
    if (((token === import33.TemplateRef) && (31 === requestNodeIndex))) { return this._TemplateRef_31_5; }
    if (((token === import35.NgIf) && (31 === requestNodeIndex))) { return this._NgIf_31_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_8_0_0:any = this._map_52('fees.FEEIDENTIFIER.esName','fees.FEEIDENTIFIER.esName');
    this._SaraInputA2Component_8_3.check_messages(currVal_8_0_0,throwOnChange,false);
    const currVal_8_0_1:any = 'newIdentifierNameES';
    this._SaraInputA2Component_8_3.check_name(currVal_8_0_1,throwOnChange,false);
    const currVal_8_0_2:any = 50;
    this._SaraInputA2Component_8_3.check_maxlength(currVal_8_0_2,throwOnChange,false);
    const currVal_8_0_3:any = false;
    this._SaraInputA2Component_8_3.check_required(currVal_8_0_3,throwOnChange,false);
    const currVal_8_0_4:any = this.parentView.context.newFeeIdentifierNamesByLang.ES;
    this._SaraInputA2Component_8_3.check_model(currVal_8_0_4,throwOnChange,false);
    this._SaraInputA2Component_8_3.ngDoCheck(this,this._el_8,throwOnChange);
    const currVal_14_0_0:any = this._map_53('fees.FEEIDENTIFIER.enName','fees.FEEIDENTIFIER.enName');
    this._SaraInputA2Component_14_3.check_messages(currVal_14_0_0,throwOnChange,false);
    const currVal_14_0_1:any = 'newIdentifierNameEN';
    this._SaraInputA2Component_14_3.check_name(currVal_14_0_1,throwOnChange,false);
    const currVal_14_0_2:any = 50;
    this._SaraInputA2Component_14_3.check_maxlength(currVal_14_0_2,throwOnChange,false);
    const currVal_14_0_3:any = false;
    this._SaraInputA2Component_14_3.check_required(currVal_14_0_3,throwOnChange,false);
    const currVal_14_0_4:any = this.parentView.context.newFeeIdentifierNamesByLang.EN;
    this._SaraInputA2Component_14_3.check_model(currVal_14_0_4,throwOnChange,false);
    this._SaraInputA2Component_14_3.ngDoCheck(this,this._el_14,throwOnChange);
    const currVal_20_0_0:any = this._map_54('fees.FEEIDENTIFIER.ptName','fees.FEEIDENTIFIER.ptName');
    this._SaraInputA2Component_20_3.check_messages(currVal_20_0_0,throwOnChange,false);
    const currVal_20_0_1:any = 'newIdentifierNamePT';
    this._SaraInputA2Component_20_3.check_name(currVal_20_0_1,throwOnChange,false);
    const currVal_20_0_2:any = 50;
    this._SaraInputA2Component_20_3.check_maxlength(currVal_20_0_2,throwOnChange,false);
    const currVal_20_0_3:any = false;
    this._SaraInputA2Component_20_3.check_required(currVal_20_0_3,throwOnChange,false);
    const currVal_20_0_4:any = this.parentView.context.newFeeIdentifierNamesByLang.PT;
    this._SaraInputA2Component_20_3.check_model(currVal_20_0_4,throwOnChange,false);
    this._SaraInputA2Component_20_3.ngDoCheck(this,this._el_20,throwOnChange);
    const currVal_29_0_0:boolean = !this.parentView.context.creatingFeeIdentifier;
    this._NgIf_29_6.check_ngIf(currVal_29_0_0,throwOnChange,false);
    this._NgIf_29_6.ngDoCheck(this,this._anchor_29,throwOnChange);
    const currVal_31_0_0:any = this.parentView.context.creatingFeeIdentifier;
    this._NgIf_31_6.check_ngIf(currVal_31_0_0,throwOnChange,false);
    this._NgIf_31_6.ngDoCheck(this,this._anchor_31,throwOnChange);
    this._vc_29.detectChangesInNestedViews(throwOnChange);
    this._vc_31.detectChangesInNestedViews(throwOnChange);
    this.compView_8.internalDetectChanges(throwOnChange);
    this.compView_14.internalDetectChanges(throwOnChange);
    this.compView_20.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_29.destroyNestedViews();
    this._vc_31.destroyNestedViews();
    this.compView_8.destroy();
    this.compView_14.destroy();
    this.compView_20.destroy();
    this._SaraInputA2Component_8_3.ngOnDestroy();
    this._SaraInputA2Component_14_3.ngOnDestroy();
    this._SaraInputA2Component_20_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 29)) { return new View_PickupPointFeeEditComponent5(this.viewUtils,this,29,this._anchor_29,this._vc_29); }
    if ((nodeIndex == 31)) { return new View_PickupPointFeeEditComponent6(this.viewUtils,this,31,this._anchor_31,this._vc_31); }
    return (null as any);
  }
  handleEvent_8(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.newFeeIdentifierNamesByLang.ES = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_14(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.newFeeIdentifierNamesByLang.EN = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_20(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.newFeeIdentifierNamesByLang.PT = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_PickupPointFeeEditComponent7 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import23.SaraRadioComponent>;
  _SaraRadioComponent_2_3:import24.Wrapper_SaraRadioComponent;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import25.ViewContainer) {
    super(View_PickupPointFeeEditComponent7,renderType_PickupPointFeeEditComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-md-4 -sm-12'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'sara-radio',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import24.View_SaraRadioComponent0(this.viewUtils,this,2,this._el_2);
    this._SaraRadioComponent_2_3 = new import24.Wrapper_SaraRadioComponent();
    this._text_3 = this.renderer.createText((null as any),'\n                                                ',(null as any));
    this.compView_2.create(this._SaraRadioComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray4(4,'change',(null as any),'modelChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this._SaraRadioComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),true,true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.SaraRadioComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._SaraRadioComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = 'amountType';
    this._SaraRadioComponent_2_3.check_name(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this.context.$implicit;
    this._SaraRadioComponent_2_3.check_item(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = this.parentView.context.fee.amountType;
    this._SaraRadioComponent_2_3.check_model(currVal_2_0_2,throwOnChange,false);
    this._SaraRadioComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._SaraRadioComponent_2_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'change')) {
      const pd_sub_0:any = ((<any>this.parentView.context.amountTypeChange()) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'modelChange')) {
      const pd_sub_1:any = ((<any>(this.parentView.context.fee.amountType = $event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_PickupPointFeeEditComponent8 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import23.SaraRadioComponent>;
  _SaraRadioComponent_2_3:import24.Wrapper_SaraRadioComponent;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import25.ViewContainer) {
    super(View_PickupPointFeeEditComponent8,renderType_PickupPointFeeEditComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-md-4 -sm-12'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'sara-radio',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import24.View_SaraRadioComponent0(this.viewUtils,this,2,this._el_2);
    this._SaraRadioComponent_2_3 = new import24.Wrapper_SaraRadioComponent();
    this._text_3 = this.renderer.createText((null as any),'\n                                                ',(null as any));
    this.compView_2.create(this._SaraRadioComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this._SaraRadioComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),false,true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.SaraRadioComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._SaraRadioComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = 'feeApplyToRadio';
    this._SaraRadioComponent_2_3.check_name(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this.context.$implicit;
    this._SaraRadioComponent_2_3.check_item(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = this.parentView.context.fee.origin;
    this._SaraRadioComponent_2_3.check_model(currVal_2_0_2,throwOnChange,false);
    this._SaraRadioComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._SaraRadioComponent_2_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.fee.origin = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_PickupPointFeeEditComponent9 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import28.EvaButtonComponent>;
  _EvaButtonComponent_0_3:import29.Wrapper_EvaButtonComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import25.ViewContainer) {
    super(View_PickupPointFeeEditComponent9,renderType_PickupPointFeeEditComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'eva-button',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_0 = new import29.View_EvaButtonComponent0(this.viewUtils,this,0,this._el_0);
    this._EvaButtonComponent_0_3 = new import29.Wrapper_EvaButtonComponent();
    this.compView_0.create(this._EvaButtonComponent_0_3.context);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'action',(null as any)),this.eventHandler(this.handleEvent_0));
    this._EvaButtonComponent_0_3.subscribe(this,this.eventHandler(this.handleEvent_0),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import28.EvaButtonComponent) && (0 === requestNodeIndex))) { return this._EvaButtonComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.parentView.context.saveButton;
    this._EvaButtonComponent_0_3.check_button(currVal_0_0_0,throwOnChange,false);
    this._EvaButtonComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._EvaButtonComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'action')) {
      const pd_sub_0:any = ((<any>this.parentView.context.save()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_PickupPointFeeEditComponent10 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import28.EvaButtonComponent>;
  _EvaButtonComponent_0_3:import29.Wrapper_EvaButtonComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import25.ViewContainer) {
    super(View_PickupPointFeeEditComponent10,renderType_PickupPointFeeEditComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'eva-button',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_0 = new import29.View_EvaButtonComponent0(this.viewUtils,this,0,this._el_0);
    this._EvaButtonComponent_0_3 = new import29.Wrapper_EvaButtonComponent();
    this.compView_0.create(this._EvaButtonComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import28.EvaButtonComponent) && (0 === requestNodeIndex))) { return this._EvaButtonComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.parentView.context.savingButton;
    this._EvaButtonComponent_0_3.check_button(currVal_0_0_0,throwOnChange,false);
    this._EvaButtonComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._EvaButtonComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_PickupPointFeeEditComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_PickupPointFeeEditComponent,{});
export class View_PickupPointFeeEditComponent0 extends import1.AppView<import0.PickupPointFeeEditComponent> {
  _viewQuery_feeForm_0:import36.QueryList<any>;
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  _text_26:any;
  _el_27:any;
  _NgForm_27_3:import37.Wrapper_NgForm;
  _ControlContainer_27_4:any;
  _NgControlStatusGroup_27_5:import38.Wrapper_NgControlStatusGroup;
  _text_28:any;
  _el_29:any;
  compView_29:import1.AppView<import39.FormCardComponent>;
  _FormCardComponent_29_3:import40.Wrapper_FormCardComponent;
  _text_30:any;
  _el_31:any;
  _text_32:any;
  _el_33:any;
  _text_34:any;
  _el_35:any;
  _text_36:any;
  _text_37:any;
  _el_38:any;
  _text_39:any;
  _anchor_40:any;
  /*private*/ _vc_40:import25.ViewContainer;
  _TemplateRef_40_5:any;
  _NgFor_40_6:import41.Wrapper_NgFor;
  _text_41:any;
  _text_42:any;
  _text_43:any;
  _text_44:any;
  _el_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _el_49:any;
  _text_50:any;
  _el_51:any;
  _text_52:any;
  _text_53:any;
  _el_54:any;
  compView_54:import1.AppView<import42.SaraSelectComponent>;
  _SaraSelectComponent_54_3:import43.Wrapper_SaraSelectComponent;
  _text_55:any;
  _text_56:any;
  _text_57:any;
  _el_58:any;
  _text_59:any;
  _el_60:any;
  _text_61:any;
  _text_62:any;
  _el_63:any;
  compView_63:import1.AppView<import42.SaraSelectComponent>;
  _SaraSelectComponent_63_3:import43.Wrapper_SaraSelectComponent;
  _text_64:any;
  _text_65:any;
  _text_66:any;
  _anchor_67:any;
  /*private*/ _vc_67:import25.ViewContainer;
  _TemplateRef_67_5:any;
  _NgIf_67_6:import32.Wrapper_NgIf;
  _text_68:any;
  _text_69:any;
  _text_70:any;
  _anchor_71:any;
  /*private*/ _vc_71:import25.ViewContainer;
  _TemplateRef_71_5:any;
  _NgIf_71_6:import32.Wrapper_NgIf;
  _text_72:any;
  _text_73:any;
  _anchor_74:any;
  /*private*/ _vc_74:import25.ViewContainer;
  _TemplateRef_74_5:any;
  _NgIf_74_6:import32.Wrapper_NgIf;
  _text_75:any;
  _text_76:any;
  _el_77:any;
  _text_78:any;
  _el_79:any;
  _text_80:any;
  _el_81:any;
  _text_82:any;
  _text_83:any;
  _el_84:any;
  _text_85:any;
  _anchor_86:any;
  /*private*/ _vc_86:import25.ViewContainer;
  _TemplateRef_86_5:any;
  _NgFor_86_6:import41.Wrapper_NgFor;
  _text_87:any;
  _text_88:any;
  _text_89:any;
  _text_90:any;
  _text_91:any;
  _el_92:any;
  compView_92:import1.AppView<import39.FormCardComponent>;
  _FormCardComponent_92_3:import40.Wrapper_FormCardComponent;
  _text_93:any;
  _el_94:any;
  _text_95:any;
  _el_96:any;
  _text_97:any;
  _el_98:any;
  compView_98:import1.AppView<import30.SaraInputA2Component>;
  _SaraInputA2Component_98_3:import31.Wrapper_SaraInputA2Component;
  __NG_VALUE_ACCESSOR_98_4:any[];
  _text_99:any;
  _text_100:any;
  _text_101:any;
  _el_102:any;
  _text_103:any;
  _el_104:any;
  _text_105:any;
  _text_106:any;
  _el_107:any;
  _text_108:any;
  _text_109:any;
  _text_110:any;
  _text_111:any;
  _el_112:any;
  _text_113:any;
  _el_114:any;
  _text_115:any;
  _el_116:any;
  compView_116:import1.AppView<import42.SaraSelectComponent>;
  _SaraSelectComponent_116_3:import43.Wrapper_SaraSelectComponent;
  _text_117:any;
  _text_118:any;
  _text_119:any;
  _text_120:any;
  _el_121:any;
  _text_122:any;
  _el_123:any;
  _text_124:any;
  _el_125:any;
  _text_126:any;
  _text_127:any;
  _el_128:any;
  _text_129:any;
  _anchor_130:any;
  /*private*/ _vc_130:import25.ViewContainer;
  _TemplateRef_130_5:any;
  _NgFor_130_6:import41.Wrapper_NgFor;
  _text_131:any;
  _text_132:any;
  _text_133:any;
  _text_134:any;
  _text_135:any;
  _el_136:any;
  compView_136:import1.AppView<import39.FormCardComponent>;
  _FormCardComponent_136_3:import40.Wrapper_FormCardComponent;
  _text_137:any;
  _el_138:any;
  _text_139:any;
  _el_140:any;
  compView_140:import1.AppView<import44.SaraSelectorComponent>;
  _SaraSelectorComponent_140_3:import45.Wrapper_SaraSelectorComponent;
  _text_141:any;
  _text_142:any;
  _text_143:any;
  _text_144:any;
  _el_145:any;
  compView_145:import1.AppView<import39.FormCardComponent>;
  _FormCardComponent_145_3:import40.Wrapper_FormCardComponent;
  _text_146:any;
  _el_147:any;
  _text_148:any;
  _el_149:any;
  compView_149:import1.AppView<import44.SaraSelectorComponent>;
  _SaraSelectorComponent_149_3:import45.Wrapper_SaraSelectorComponent;
  _text_150:any;
  _text_151:any;
  _text_152:any;
  _text_153:any;
  _text_154:any;
  _el_155:any;
  _text_156:any;
  _el_157:any;
  _text_158:any;
  _anchor_159:any;
  /*private*/ _vc_159:import25.ViewContainer;
  _TemplateRef_159_5:any;
  _NgIf_159_6:import32.Wrapper_NgIf;
  _text_160:any;
  _anchor_161:any;
  /*private*/ _vc_161:import25.ViewContainer;
  _TemplateRef_161_5:any;
  _NgIf_161_6:import32.Wrapper_NgIf;
  _text_162:any;
  _el_163:any;
  compView_163:import1.AppView<import28.EvaButtonComponent>;
  _EvaButtonComponent_163_3:import29.Wrapper_EvaButtonComponent;
  _text_164:any;
  _text_165:any;
  _text_166:any;
  _text_167:any;
  _text_168:any;
  _text_169:any;
  _text_170:any;
  _text_171:any;
  _text_172:any;
  /*private*/ _expr_224:any;
  _pipe_translate_0:import26.TranslatePipe;
  /*private*/ _expr_226:any;
  _pipe_translate_1:import26.TranslatePipe;
  /*private*/ _expr_228:any;
  _pipe_translate_2:import26.TranslatePipe;
  _map_230:any;
  /*private*/ _expr_231:any;
  _pipe_translate_3:import26.TranslatePipe;
  _map_233:any;
  /*private*/ _expr_234:any;
  _pipe_translate_4:import26.TranslatePipe;
  _map_236:any;
  _map_237:any;
  /*private*/ _expr_238:any;
  /*private*/ _expr_239:any;
  /*private*/ _expr_240:any;
  _map_241:any;
  /*private*/ _expr_242:any;
  _pipe_translate_5:import26.TranslatePipe;
  _map_244:any;
  _map_245:any;
  /*private*/ _expr_246:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_PickupPointFeeEditComponent0,renderType_PickupPointFeeEditComponent,import9.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways);
    this._expr_224 = import27.UNINITIALIZED;
    this._expr_226 = import27.UNINITIALIZED;
    this._expr_228 = import27.UNINITIALIZED;
    this._map_230 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        name: p0,
        itemList: p1
      }
      ;
    });
    this._expr_231 = import27.UNINITIALIZED;
    this._map_233 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        name: p0,
        itemList: p1
      }
      ;
    });
    this._expr_234 = import27.UNINITIALIZED;
    this._map_236 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        title: p0,
        subtitle: p1
      }
      ;
    });
    this._map_237 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        name: p0,
        placeholder: p1
      }
      ;
    });
    this._expr_238 = import27.UNINITIALIZED;
    this._expr_239 = import27.UNINITIALIZED;
    this._expr_240 = import27.UNINITIALIZED;
    this._map_241 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        name: p0,
        itemList: p1
      }
      ;
    });
    this._expr_242 = import27.UNINITIALIZED;
    this._map_244 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {title: p0};
    });
    this._map_245 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {title: p0};
    });
    this._expr_246 = import27.UNINITIALIZED;
  }
  get _NG_VALUE_ACCESSOR_98_4():any[] {
    if ((this.__NG_VALUE_ACCESSOR_98_4 == null)) { (this.__NG_VALUE_ACCESSOR_98_4 = [this._SaraInputA2Component_98_3.context]); }
    return this.__NG_VALUE_ACCESSOR_98_4;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._viewQuery_feeForm_0 = new import36.QueryList<any>();
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-slide -up -start'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','container-fluid whitesmoke-section'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-container'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-grid'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-lg'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','-md-12 -sm-12'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-lg'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                            ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_12,'div',new import3.InlineArray2(2,'class','-md-4'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n                                ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_14,'span',new import3.InlineArray2(2,'class','-h1'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'',(null as any));
    this._text_18 = this.renderer.createText(this._el_14,'\n                            ',(null as any));
    this._text_19 = this.renderer.createText(this._el_12,'\n                            ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_12,'div',new import3.InlineArray2(2,'class','-md-8 -eva-3-mt-sm'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n                                ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_20,'div',new import3.InlineArray2(2,'class','header-line'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,' ',(null as any));
    this._text_24 = this.renderer.createText(this._el_20,'\n                            ',(null as any));
    this._text_25 = this.renderer.createText(this._el_12,'\n                        ',(null as any));
    this._text_26 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_27 = import3.createRenderElement(this.renderer,this._el_10,'form',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._NgForm_27_3 = new import37.Wrapper_NgForm((null as any),(null as any));
    this._ControlContainer_27_4 = this._NgForm_27_3.context;
    this._NgControlStatusGroup_27_5 = new import38.Wrapper_NgControlStatusGroup(this._ControlContainer_27_4);
    this._text_28 = this.renderer.createText(this._el_27,'\n                            ',(null as any));
    this._el_29 = import3.createRenderElement(this.renderer,this._el_27,'form-card',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_29 = new import40.View_FormCardComponent0(this.viewUtils,this,29,this._el_29);
    this._FormCardComponent_29_3 = new import40.Wrapper_FormCardComponent();
    this._text_30 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this._el_31 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray4(4,'class','-md-12 -sm-12','qadata','category'),(null as any));
    this._text_32 = this.renderer.createText(this._el_31,'\n                                    ',(null as any));
    this._el_33 = import3.createRenderElement(this.renderer,this._el_31,'div',new import3.InlineArray2(2,'class','eva-3-input -md -validate -validate-sm -top-right'),(null as any));
    this._text_34 = this.renderer.createText(this._el_33,'\n                                        ',(null as any));
    this._el_35 = import3.createRenderElement(this.renderer,this._el_33,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md required-field'),(null as any));
    this._text_36 = this.renderer.createText(this._el_35,'',(null as any));
    this._text_37 = this.renderer.createText(this._el_33,'\n                                        ',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_33,'div',new import3.InlineArray2(2,'class','input-container'),(null as any));
    this._text_39 = this.renderer.createText(this._el_38,'\n                                            ',(null as any));
    this._anchor_40 = this.renderer.createTemplateAnchor(this._el_38,(null as any));
    this._vc_40 = new import25.ViewContainer(40,38,this,this._anchor_40);
    this._TemplateRef_40_5 = new import33.TemplateRef_(this,40,this._anchor_40);
    this._NgFor_40_6 = new import41.Wrapper_NgFor(this._vc_40.vcRef,this._TemplateRef_40_5,this.parentView.injectorGet(import46.IterableDiffers,this.parentIndex),this.ref);
    this._text_41 = this.renderer.createText(this._el_38,'\n                                        ',(null as any));
    this._text_42 = this.renderer.createText(this._el_33,'\n                                    ',(null as any));
    this._text_43 = this.renderer.createText(this._el_31,'\n                                ',(null as any));
    this._text_44 = this.renderer.createText((null as any),'\n\n                                ',(null as any));
    this._el_45 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-md-12 -sm-12 -eva-3-mt-lg'),(null as any));
    this._text_46 = this.renderer.createText(this._el_45,'\n                                    ',(null as any));
    this._el_47 = import3.createRenderElement(this.renderer,this._el_45,'div',new import3.InlineArray4(4,'class','eva-3-row','qadata','feeIdentifierLang'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'\n                                        ',(null as any));
    this._el_49 = import3.createRenderElement(this.renderer,this._el_47,'div',new import3.InlineArray2(2,'class','col -md-4 -sm-12'),(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'\n                                            ',(null as any));
    this._el_51 = import3.createRenderElement(this.renderer,this._el_49,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md'),(null as any));
    this._text_52 = this.renderer.createText(this._el_51,'',(null as any));
    this._text_53 = this.renderer.createText(this._el_49,'\n                                            ',(null as any));
    this._el_54 = import3.createRenderElement(this.renderer,this._el_49,'sara-select',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_54 = new import43.View_SaraSelectComponent0(this.viewUtils,this,54,this._el_54);
    this._SaraSelectComponent_54_3 = new import43.Wrapper_SaraSelectComponent();
    this._text_55 = this.renderer.createText((null as any),'\n                                            ',(null as any));
    this.compView_54.create(this._SaraSelectComponent_54_3.context);
    this._text_56 = this.renderer.createText(this._el_49,'\n                                        ',(null as any));
    this._text_57 = this.renderer.createText(this._el_47,'\n                                 \n                                        ',(null as any));
    this._el_58 = import3.createRenderElement(this.renderer,this._el_47,'div',new import3.InlineArray2(2,'class','col -md-4 -sm-12'),(null as any));
    this._text_59 = this.renderer.createText(this._el_58,'\n                                            ',(null as any));
    this._el_60 = import3.createRenderElement(this.renderer,this._el_58,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md'),(null as any));
    this._text_61 = this.renderer.createText(this._el_60,'',(null as any));
    this._text_62 = this.renderer.createText(this._el_58,'\n                                            ',(null as any));
    this._el_63 = import3.createRenderElement(this.renderer,this._el_58,'sara-select',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_63 = new import43.View_SaraSelectComponent0(this.viewUtils,this,63,this._el_63);
    this._SaraSelectComponent_63_3 = new import43.Wrapper_SaraSelectComponent();
    this._text_64 = this.renderer.createText((null as any),'\n                                            ',(null as any));
    this.compView_63.create(this._SaraSelectComponent_63_3.context);
    this._text_65 = this.renderer.createText(this._el_58,'\n                                        ',(null as any));
    this._text_66 = this.renderer.createText(this._el_47,'\n\n                                        ',(null as any));
    this._anchor_67 = this.renderer.createTemplateAnchor(this._el_47,(null as any));
    this._vc_67 = new import25.ViewContainer(67,47,this,this._anchor_67);
    this._TemplateRef_67_5 = new import33.TemplateRef_(this,67,this._anchor_67);
    this._NgIf_67_6 = new import32.Wrapper_NgIf(this._vc_67.vcRef,this._TemplateRef_67_5);
    this._text_68 = this.renderer.createText(this._el_47,'\n                                    ',(null as any));
    this._text_69 = this.renderer.createText(this._el_45,'\n                                ',(null as any));
    this._text_70 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this._anchor_71 = this.renderer.createTemplateAnchor((null as any),(null as any));
    this._vc_71 = new import25.ViewContainer(71,29,this,this._anchor_71);
    this._TemplateRef_71_5 = new import33.TemplateRef_(this,71,this._anchor_71);
    this._NgIf_71_6 = new import32.Wrapper_NgIf(this._vc_71.vcRef,this._TemplateRef_71_5);
    this._text_72 = this.renderer.createText((null as any),'\n\n                                ',(null as any));
    this._text_73 = this.renderer.createText((null as any),'\n\n                                ',(null as any));
    this._anchor_74 = this.renderer.createTemplateAnchor((null as any),(null as any));
    this._vc_74 = new import25.ViewContainer(74,29,this,this._anchor_74);
    this._TemplateRef_74_5 = new import33.TemplateRef_(this,74,this._anchor_74);
    this._NgIf_74_6 = new import32.Wrapper_NgIf(this._vc_74.vcRef,this._TemplateRef_74_5);
    this._text_75 = this.renderer.createText((null as any),'\n\n                                ',(null as any));
    this._text_76 = this.renderer.createText((null as any),'\n\n                                ',(null as any));
    this._el_77 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray4(4,'class','-md-12 -sm-12 -eva-3-mt-lg','qadata','amountType'),(null as any));
    this._text_78 = this.renderer.createText(this._el_77,'\n                                    ',(null as any));
    this._el_79 = import3.createRenderElement(this.renderer,this._el_77,'div',new import3.InlineArray2(2,'class','eva-3-input -md -validate -validate-sm -top-right'),(null as any));
    this._text_80 = this.renderer.createText(this._el_79,'\n                                        ',(null as any));
    this._el_81 = import3.createRenderElement(this.renderer,this._el_79,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md required-field'),(null as any));
    this._text_82 = this.renderer.createText(this._el_81,'',(null as any));
    this._text_83 = this.renderer.createText(this._el_79,'\n                                        ',(null as any));
    this._el_84 = import3.createRenderElement(this.renderer,this._el_79,'div',new import3.InlineArray2(2,'class','input-container'),(null as any));
    this._text_85 = this.renderer.createText(this._el_84,'\n                                            ',(null as any));
    this._anchor_86 = this.renderer.createTemplateAnchor(this._el_84,(null as any));
    this._vc_86 = new import25.ViewContainer(86,84,this,this._anchor_86);
    this._TemplateRef_86_5 = new import33.TemplateRef_(this,86,this._anchor_86);
    this._NgFor_86_6 = new import41.Wrapper_NgFor(this._vc_86.vcRef,this._TemplateRef_86_5,this.parentView.injectorGet(import46.IterableDiffers,this.parentIndex),this.ref);
    this._text_87 = this.renderer.createText(this._el_84,'\n                                        ',(null as any));
    this._text_88 = this.renderer.createText(this._el_79,'\n                                    ',(null as any));
    this._text_89 = this.renderer.createText(this._el_77,'\n                                ',(null as any));
    this._text_90 = this.renderer.createText((null as any),'\n                            ',(null as any));
    this.compView_29.create(this._FormCardComponent_29_3.context);
    this._text_91 = this.renderer.createText(this._el_27,'\n                            ',(null as any));
    this._el_92 = import3.createRenderElement(this.renderer,this._el_27,'form-card',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_92 = new import40.View_FormCardComponent0(this.viewUtils,this,92,this._el_92);
    this._FormCardComponent_92_3 = new import40.Wrapper_FormCardComponent();
    this._text_93 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this._el_94 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-md-12 -sm-12'),(null as any));
    this._text_95 = this.renderer.createText(this._el_94,'\n                                    ',(null as any));
    this._el_96 = import3.createRenderElement(this.renderer,this._el_94,'div',new import3.InlineArray2(2,'class','eva-3-row -md-3 -sm-10'),(null as any));
    this._text_97 = this.renderer.createText(this._el_96,'\n                                        ',(null as any));
    this._el_98 = import3.createRenderElement(this.renderer,this._el_96,'sara-input-a2',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_98 = new import31.View_SaraInputA2Component0(this.viewUtils,this,98,this._el_98);
    this._SaraInputA2Component_98_3 = new import31.Wrapper_SaraInputA2Component();
    this._text_99 = this.renderer.createText((null as any),'\n                                        ',(null as any));
    this.compView_98.create(this._SaraInputA2Component_98_3.context);
    this._text_100 = this.renderer.createText(this._el_96,'\n                                    ',(null as any));
    this._text_101 = this.renderer.createText(this._el_94,'\n                                    ',(null as any));
    this._el_102 = import3.createRenderElement(this.renderer,this._el_94,'div',new import3.InlineArray2(2,'class','-md-1 -sm-2 -eva-3-mt-lg -eva-3-pt-xlg'),(null as any));
    this._text_103 = this.renderer.createText(this._el_102,'\n                                        ',(null as any));
    this._el_104 = import3.createRenderElement(this.renderer,this._el_102,'span',new import3.InlineArray2(2,'class','-h5'),(null as any));
    this._text_105 = this.renderer.createText(this._el_104,'%',(null as any));
    this._text_106 = this.renderer.createText(this._el_102,'\n                                        ',(null as any));
    this._el_107 = import3.createRenderElement(this.renderer,this._el_102,'span',new import3.InlineArray2(2,'class','percentage-label'),(null as any));
    this._text_108 = this.renderer.createText(this._el_107,'',(null as any));
    this._text_109 = this.renderer.createText(this._el_102,'\n                                    ',(null as any));
    this._text_110 = this.renderer.createText(this._el_94,'\n                                ',(null as any));
    this._text_111 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this._el_112 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-md-12 -sm-12'),(null as any));
    this._text_113 = this.renderer.createText(this._el_112,'\n                                    ',(null as any));
    this._el_114 = import3.createRenderElement(this.renderer,this._el_112,'div',new import3.InlineArray4(4,'class','eva-3-row -md-4 -sm-12','qadata','feePaymentType'),(null as any));
    this._text_115 = this.renderer.createText(this._el_114,'\n                                        ',(null as any));
    this._el_116 = import3.createRenderElement(this.renderer,this._el_114,'sara-select',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_116 = new import43.View_SaraSelectComponent0(this.viewUtils,this,116,this._el_116);
    this._SaraSelectComponent_116_3 = new import43.Wrapper_SaraSelectComponent();
    this._text_117 = this.renderer.createText((null as any),'\n                                        ',(null as any));
    this.compView_116.create(this._SaraSelectComponent_116_3.context);
    this._text_118 = this.renderer.createText(this._el_114,'\n                                    ',(null as any));
    this._text_119 = this.renderer.createText(this._el_112,'\n                                ',(null as any));
    this._text_120 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this._el_121 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray4(4,'class','-md-12 -sm-12 -eva-3-mt-lg','qadata','applyToRadio'),(null as any));
    this._text_122 = this.renderer.createText(this._el_121,'\n                                    ',(null as any));
    this._el_123 = import3.createRenderElement(this.renderer,this._el_121,'div',new import3.InlineArray2(2,'class','eva-3-input -md -validate -validate-sm -top-right'),(null as any));
    this._text_124 = this.renderer.createText(this._el_123,'\n                                        ',(null as any));
    this._el_125 = import3.createRenderElement(this.renderer,this._el_123,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md required-field'),(null as any));
    this._text_126 = this.renderer.createText(this._el_125,'',(null as any));
    this._text_127 = this.renderer.createText(this._el_123,'\n                                        ',(null as any));
    this._el_128 = import3.createRenderElement(this.renderer,this._el_123,'div',new import3.InlineArray2(2,'class','input-container'),(null as any));
    this._text_129 = this.renderer.createText(this._el_128,'\n                                            ',(null as any));
    this._anchor_130 = this.renderer.createTemplateAnchor(this._el_128,(null as any));
    this._vc_130 = new import25.ViewContainer(130,128,this,this._anchor_130);
    this._TemplateRef_130_5 = new import33.TemplateRef_(this,130,this._anchor_130);
    this._NgFor_130_6 = new import41.Wrapper_NgFor(this._vc_130.vcRef,this._TemplateRef_130_5,this.parentView.injectorGet(import46.IterableDiffers,this.parentIndex),this.ref);
    this._text_131 = this.renderer.createText(this._el_128,'\n                                        ',(null as any));
    this._text_132 = this.renderer.createText(this._el_123,'\n                                    ',(null as any));
    this._text_133 = this.renderer.createText(this._el_121,'\n                                ',(null as any));
    this._text_134 = this.renderer.createText((null as any),'\n                            ',(null as any));
    this.compView_92.create(this._FormCardComponent_92_3.context);
    this._text_135 = this.renderer.createText(this._el_27,'\n                            ',(null as any));
    this._el_136 = import3.createRenderElement(this.renderer,this._el_27,'form-card',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_136 = new import40.View_FormCardComponent0(this.viewUtils,this,136,this._el_136);
    this._FormCardComponent_136_3 = new import40.Wrapper_FormCardComponent();
    this._text_137 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this._el_138 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'qadata','pointOfSaleSelector'),(null as any));
    this._text_139 = this.renderer.createText(this._el_138,'\n                                ',(null as any));
    this._el_140 = import3.createRenderElement(this.renderer,this._el_138,'sara-selector',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_140 = new import45.View_SaraSelectorComponent0(this.viewUtils,this,140,this._el_140);
    this._SaraSelectorComponent_140_3 = new import45.Wrapper_SaraSelectorComponent();
    this._text_141 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this.compView_140.create(this._SaraSelectorComponent_140_3.context);
    this._text_142 = this.renderer.createText(this._el_138,'\n                                ',(null as any));
    this._text_143 = this.renderer.createText((null as any),'\n                            ',(null as any));
    this.compView_136.create(this._FormCardComponent_136_3.context);
    this._text_144 = this.renderer.createText(this._el_27,'\n                            ',(null as any));
    this._el_145 = import3.createRenderElement(this.renderer,this._el_27,'form-card',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_145 = new import40.View_FormCardComponent0(this.viewUtils,this,145,this._el_145);
    this._FormCardComponent_145_3 = new import40.Wrapper_FormCardComponent();
    this._text_146 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this._el_147 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'qadata','pickupPointSelector'),(null as any));
    this._text_148 = this.renderer.createText(this._el_147,'\n                                ',(null as any));
    this._el_149 = import3.createRenderElement(this.renderer,this._el_147,'sara-selector',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_149 = new import45.View_SaraSelectorComponent0(this.viewUtils,this,149,this._el_149);
    this._SaraSelectorComponent_149_3 = new import45.Wrapper_SaraSelectorComponent();
    this._text_150 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this.compView_149.create(this._SaraSelectorComponent_149_3.context);
    this._text_151 = this.renderer.createText(this._el_147,'\n                                ',(null as any));
    this._text_152 = this.renderer.createText((null as any),'\n                            ',(null as any));
    this.compView_145.create(this._FormCardComponent_145_3.context);
    this._text_153 = this.renderer.createText(this._el_27,'\n                            ',(null as any));
    this._text_154 = this.renderer.createText(this._el_27,'\n                            ',(null as any));
    this._el_155 = import3.createRenderElement(this.renderer,this._el_27,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-lg'),(null as any));
    this._text_156 = this.renderer.createText(this._el_155,'\n                                ',(null as any));
    this._el_157 = import3.createRenderElement(this.renderer,this._el_155,'div',new import3.InlineArray4(4,'class','-md-12','qadata','actionButtons'),(null as any));
    this._text_158 = this.renderer.createText(this._el_157,'\n                                    ',(null as any));
    this._anchor_159 = this.renderer.createTemplateAnchor(this._el_157,(null as any));
    this._vc_159 = new import25.ViewContainer(159,157,this,this._anchor_159);
    this._TemplateRef_159_5 = new import33.TemplateRef_(this,159,this._anchor_159);
    this._NgIf_159_6 = new import32.Wrapper_NgIf(this._vc_159.vcRef,this._TemplateRef_159_5);
    this._text_160 = this.renderer.createText(this._el_157,'\n                                    ',(null as any));
    this._anchor_161 = this.renderer.createTemplateAnchor(this._el_157,(null as any));
    this._vc_161 = new import25.ViewContainer(161,157,this,this._anchor_161);
    this._TemplateRef_161_5 = new import33.TemplateRef_(this,161,this._anchor_161);
    this._NgIf_161_6 = new import32.Wrapper_NgIf(this._vc_161.vcRef,this._TemplateRef_161_5);
    this._text_162 = this.renderer.createText(this._el_157,'\n                                    ',(null as any));
    this._el_163 = import3.createRenderElement(this.renderer,this._el_157,'eva-button',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_163 = new import29.View_EvaButtonComponent0(this.viewUtils,this,163,this._el_163);
    this._EvaButtonComponent_163_3 = new import29.Wrapper_EvaButtonComponent();
    this.compView_163.create(this._EvaButtonComponent_163_3.context);
    this._text_164 = this.renderer.createText(this._el_157,'\n                                ',(null as any));
    this._text_165 = this.renderer.createText(this._el_155,'\n                            ',(null as any));
    this._text_166 = this.renderer.createText(this._el_27,'\n                        ',(null as any));
    this._text_167 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._text_168 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_169 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_170 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_171 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_172 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._pipe_translate_0 = new import26.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_27,new import3.InlineArray4(4,'submit',(null as any),'reset',(null as any)),this.eventHandler(this.handleEvent_27));
    this._pipe_translate_1 = new import26.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import26.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_54,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_54));
    this._SaraSelectComponent_54_3.subscribe(this,this.eventHandler(this.handleEvent_54),true);
    this._pipe_translate_3 = new import26.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_63,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_63));
    this._SaraSelectComponent_63_3.subscribe(this,this.eventHandler(this.handleEvent_63),true);
    this._pipe_translate_4 = new import26.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_98,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_98));
    this._SaraInputA2Component_98_3.subscribe(this,this.eventHandler(this.handleEvent_98),true);
    var disposable_4:Function = import3.subscribeToRenderElement(this,this._el_116,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_116));
    this._SaraSelectComponent_116_3.subscribe(this,this.eventHandler(this.handleEvent_116),true);
    this._pipe_translate_5 = new import26.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_5:Function = import3.subscribeToRenderElement(this,this._el_163,new import3.InlineArray2(2,'action',(null as any)),this.eventHandler(this.handleEvent_163));
    this._EvaButtonComponent_163_3.subscribe(this,this.eventHandler(this.handleEvent_163),true);
    this._viewQuery_feeForm_0.reset([this._NgForm_27_3.context]);
    this.context.form = this._viewQuery_feeForm_0.first;
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._text_24,
      this._text_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._el_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._el_33,
      this._text_34,
      this._el_35,
      this._text_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._anchor_40,
      this._text_41,
      this._text_42,
      this._text_43,
      this._text_44,
      this._el_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._el_51,
      this._text_52,
      this._text_53,
      this._el_54,
      this._text_55,
      this._text_56,
      this._text_57,
      this._el_58,
      this._text_59,
      this._el_60,
      this._text_61,
      this._text_62,
      this._el_63,
      this._text_64,
      this._text_65,
      this._text_66,
      this._anchor_67,
      this._text_68,
      this._text_69,
      this._text_70,
      this._anchor_71,
      this._text_72,
      this._text_73,
      this._anchor_74,
      this._text_75,
      this._text_76,
      this._el_77,
      this._text_78,
      this._el_79,
      this._text_80,
      this._el_81,
      this._text_82,
      this._text_83,
      this._el_84,
      this._text_85,
      this._anchor_86,
      this._text_87,
      this._text_88,
      this._text_89,
      this._text_90,
      this._text_91,
      this._el_92,
      this._text_93,
      this._el_94,
      this._text_95,
      this._el_96,
      this._text_97,
      this._el_98,
      this._text_99,
      this._text_100,
      this._text_101,
      this._el_102,
      this._text_103,
      this._el_104,
      this._text_105,
      this._text_106,
      this._el_107,
      this._text_108,
      this._text_109,
      this._text_110,
      this._text_111,
      this._el_112,
      this._text_113,
      this._el_114,
      this._text_115,
      this._el_116,
      this._text_117,
      this._text_118,
      this._text_119,
      this._text_120,
      this._el_121,
      this._text_122,
      this._el_123,
      this._text_124,
      this._el_125,
      this._text_126,
      this._text_127,
      this._el_128,
      this._text_129,
      this._anchor_130,
      this._text_131,
      this._text_132,
      this._text_133,
      this._text_134,
      this._text_135,
      this._el_136,
      this._text_137,
      this._el_138,
      this._text_139,
      this._el_140,
      this._text_141,
      this._text_142,
      this._text_143,
      this._text_144,
      this._el_145,
      this._text_146,
      this._el_147,
      this._text_148,
      this._el_149,
      this._text_150,
      this._text_151,
      this._text_152,
      this._text_153,
      this._text_154,
      this._el_155,
      this._text_156,
      this._el_157,
      this._text_158,
      this._anchor_159,
      this._text_160,
      this._anchor_161,
      this._text_162,
      this._el_163,
      this._text_164,
      this._text_165,
      this._text_166,
      this._text_167,
      this._text_168,
      this._text_169,
      this._text_170,
      this._text_171,
      this._text_172
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import33.TemplateRef) && (40 === requestNodeIndex))) { return this._TemplateRef_40_5; }
    if (((token === import47.NgFor) && (40 === requestNodeIndex))) { return this._NgFor_40_6.context; }
    if (((token === import42.SaraSelectComponent) && ((54 <= requestNodeIndex) && (requestNodeIndex <= 55)))) { return this._SaraSelectComponent_54_3.context; }
    if (((token === import42.SaraSelectComponent) && ((63 <= requestNodeIndex) && (requestNodeIndex <= 64)))) { return this._SaraSelectComponent_63_3.context; }
    if (((token === import33.TemplateRef) && (67 === requestNodeIndex))) { return this._TemplateRef_67_5; }
    if (((token === import35.NgIf) && (67 === requestNodeIndex))) { return this._NgIf_67_6.context; }
    if (((token === import33.TemplateRef) && (71 === requestNodeIndex))) { return this._TemplateRef_71_5; }
    if (((token === import35.NgIf) && (71 === requestNodeIndex))) { return this._NgIf_71_6.context; }
    if (((token === import33.TemplateRef) && (74 === requestNodeIndex))) { return this._TemplateRef_74_5; }
    if (((token === import35.NgIf) && (74 === requestNodeIndex))) { return this._NgIf_74_6.context; }
    if (((token === import33.TemplateRef) && (86 === requestNodeIndex))) { return this._TemplateRef_86_5; }
    if (((token === import47.NgFor) && (86 === requestNodeIndex))) { return this._NgFor_86_6.context; }
    if (((token === import39.FormCardComponent) && ((29 <= requestNodeIndex) && (requestNodeIndex <= 90)))) { return this._FormCardComponent_29_3.context; }
    if (((token === import30.SaraInputA2Component) && ((98 <= requestNodeIndex) && (requestNodeIndex <= 99)))) { return this._SaraInputA2Component_98_3.context; }
    if (((token === import34.NG_VALUE_ACCESSOR) && ((98 <= requestNodeIndex) && (requestNodeIndex <= 99)))) { return this._NG_VALUE_ACCESSOR_98_4; }
    if (((token === import42.SaraSelectComponent) && ((116 <= requestNodeIndex) && (requestNodeIndex <= 117)))) { return this._SaraSelectComponent_116_3.context; }
    if (((token === import33.TemplateRef) && (130 === requestNodeIndex))) { return this._TemplateRef_130_5; }
    if (((token === import47.NgFor) && (130 === requestNodeIndex))) { return this._NgFor_130_6.context; }
    if (((token === import39.FormCardComponent) && ((92 <= requestNodeIndex) && (requestNodeIndex <= 134)))) { return this._FormCardComponent_92_3.context; }
    if (((token === import44.SaraSelectorComponent) && ((140 <= requestNodeIndex) && (requestNodeIndex <= 141)))) { return this._SaraSelectorComponent_140_3.context; }
    if (((token === import39.FormCardComponent) && ((136 <= requestNodeIndex) && (requestNodeIndex <= 143)))) { return this._FormCardComponent_136_3.context; }
    if (((token === import44.SaraSelectorComponent) && ((149 <= requestNodeIndex) && (requestNodeIndex <= 150)))) { return this._SaraSelectorComponent_149_3.context; }
    if (((token === import39.FormCardComponent) && ((145 <= requestNodeIndex) && (requestNodeIndex <= 152)))) { return this._FormCardComponent_145_3.context; }
    if (((token === import33.TemplateRef) && (159 === requestNodeIndex))) { return this._TemplateRef_159_5; }
    if (((token === import35.NgIf) && (159 === requestNodeIndex))) { return this._NgIf_159_6.context; }
    if (((token === import33.TemplateRef) && (161 === requestNodeIndex))) { return this._TemplateRef_161_5; }
    if (((token === import35.NgIf) && (161 === requestNodeIndex))) { return this._NgIf_161_6.context; }
    if (((token === import28.EvaButtonComponent) && (163 === requestNodeIndex))) { return this._EvaButtonComponent_163_3.context; }
    if (((token === import48.NgForm) && ((27 <= requestNodeIndex) && (requestNodeIndex <= 166)))) { return this._NgForm_27_3.context; }
    if (((token === import49.ControlContainer) && ((27 <= requestNodeIndex) && (requestNodeIndex <= 166)))) { return this._ControlContainer_27_4; }
    if (((token === import50.NgControlStatusGroup) && ((27 <= requestNodeIndex) && (requestNodeIndex <= 166)))) { return this._NgControlStatusGroup_27_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import27.ValueUnwrapper();
    this._NgForm_27_3.ngDoCheck(this,this._el_27,throwOnChange);
    this._NgControlStatusGroup_27_5.ngDoCheck(this,this._el_27,throwOnChange);
    this._FormCardComponent_29_3.ngDoCheck(this,this._el_29,throwOnChange);
    const currVal_40_0_0:any = ((this.context.data == null)? (null as any): this.context.data.categories);
    this._NgFor_40_6.check_ngForOf(currVal_40_0_0,throwOnChange,false);
    this._NgFor_40_6.ngDoCheck(this,this._anchor_40,throwOnChange);
    const currVal_54_0_0:any = 'feeIdentifierLang';
    this._SaraSelectComponent_54_3.check_name(currVal_54_0_0,throwOnChange,false);
    const currVal_54_0_1:any = this._map_230('',this.context.langsForSelect);
    this._SaraSelectComponent_54_3.check_messages(currVal_54_0_1,throwOnChange,false);
    const currVal_54_0_2:any = false;
    this._SaraSelectComponent_54_3.check_required(currVal_54_0_2,throwOnChange,false);
    const currVal_54_0_3:any = this.context.feeIdentifierLangId;
    this._SaraSelectComponent_54_3.check_model(currVal_54_0_3,throwOnChange,false);
    this._SaraSelectComponent_54_3.ngDoCheck(this,this._el_54,throwOnChange);
    const currVal_63_0_0:any = this.context.errors['identifierOid'];
    this._SaraSelectComponent_63_3.check_error(currVal_63_0_0,throwOnChange,false);
    const currVal_63_0_1:any = 'feeIdentifierName';
    this._SaraSelectComponent_63_3.check_name(currVal_63_0_1,throwOnChange,false);
    const currVal_63_0_2:any = this._map_233('',this.context.filteredFeeIdentifiersByLang);
    this._SaraSelectComponent_63_3.check_messages(currVal_63_0_2,throwOnChange,false);
    const currVal_63_0_3:any = true;
    this._SaraSelectComponent_63_3.check_required(currVal_63_0_3,throwOnChange,false);
    const currVal_63_0_4:any = this.context.feeIdentifierOid;
    this._SaraSelectComponent_63_3.check_model(currVal_63_0_4,throwOnChange,false);
    this._SaraSelectComponent_63_3.ngDoCheck(this,this._el_63,throwOnChange);
    const currVal_67_0_0:boolean = !!this.context.fee.name;
    this._NgIf_67_6.check_ngIf(currVal_67_0_0,throwOnChange,false);
    this._NgIf_67_6.ngDoCheck(this,this._anchor_67,throwOnChange);
    const currVal_71_0_0:any = this.context.hasPermissionToCreateFeeIdentifier;
    this._NgIf_71_6.check_ngIf(currVal_71_0_0,throwOnChange,false);
    this._NgIf_71_6.ngDoCheck(this,this._anchor_71,throwOnChange);
    const currVal_74_0_0:any = this.context.showCreateFeeIdentifier;
    this._NgIf_74_6.check_ngIf(currVal_74_0_0,throwOnChange,false);
    this._NgIf_74_6.ngDoCheck(this,this._anchor_74,throwOnChange);
    const currVal_86_0_0:any = ((this.context.data == null)? (null as any): this.context.data.types);
    this._NgFor_86_6.check_ngForOf(currVal_86_0_0,throwOnChange,false);
    this._NgFor_86_6.ngDoCheck(this,this._anchor_86,throwOnChange);
    const currVal_92_0_0:any = this._map_236('fees.AMOUNT','fees.INFORMATION_DECIMAL');
    this._FormCardComponent_92_3.check_message(currVal_92_0_0,throwOnChange,false);
    this._FormCardComponent_92_3.ngDoCheck(this,this._el_92,throwOnChange);
    const currVal_98_0_0:any = this._map_237('fees.AMOUNT','fees.AMOUNT');
    this._SaraInputA2Component_98_3.check_messages(currVal_98_0_0,throwOnChange,false);
    const currVal_98_0_1:any = this.context.errors['feeAmount'];
    this._SaraInputA2Component_98_3.check_error(currVal_98_0_1,throwOnChange,false);
    const currVal_98_0_2:any = 'feeAmount';
    this._SaraInputA2Component_98_3.check_name(currVal_98_0_2,throwOnChange,false);
    const currVal_98_0_3:any = true;
    this._SaraInputA2Component_98_3.check_required(currVal_98_0_3,throwOnChange,false);
    const currVal_98_0_4:any = this.context.fee.amount;
    this._SaraInputA2Component_98_3.check_model(currVal_98_0_4,throwOnChange,false);
    this._SaraInputA2Component_98_3.ngDoCheck(this,this._el_98,throwOnChange);
    const currVal_116_0_0:any = this.context.errors['feePaymentType'];
    this._SaraSelectComponent_116_3.check_error(currVal_116_0_0,throwOnChange,false);
    const currVal_116_0_1:any = 'feePaymentType';
    this._SaraSelectComponent_116_3.check_name(currVal_116_0_1,throwOnChange,false);
    const currVal_116_0_2:any = this._map_241('common.TYPE',((this.context.data == null)? (null as any): this.context.data.paymentTypes));
    this._SaraSelectComponent_116_3.check_messages(currVal_116_0_2,throwOnChange,false);
    const currVal_116_0_3:any = false;
    this._SaraSelectComponent_116_3.check_required(currVal_116_0_3,throwOnChange,false);
    const currVal_116_0_4:any = (this.context.fee.amountType == 'PERCENTAGE');
    this._SaraSelectComponent_116_3.check_disabled(currVal_116_0_4,throwOnChange,false);
    const currVal_116_0_5:any = this.context.fee.paymentType;
    this._SaraSelectComponent_116_3.check_model(currVal_116_0_5,throwOnChange,false);
    this._SaraSelectComponent_116_3.ngDoCheck(this,this._el_116,throwOnChange);
    const currVal_130_0_0:any = ((this.context.data == null)? (null as any): this.context.data.origins);
    this._NgFor_130_6.check_ngForOf(currVal_130_0_0,throwOnChange,false);
    this._NgFor_130_6.ngDoCheck(this,this._anchor_130,throwOnChange);
    const currVal_136_0_0:any = this._map_244('fees.POINTS_OF_SALE');
    this._FormCardComponent_136_3.check_message(currVal_136_0_0,throwOnChange,false);
    this._FormCardComponent_136_3.ngDoCheck(this,this._el_136,throwOnChange);
    const currVal_140_0_0:any = this.context.errors['feeSelector'];
    this._SaraSelectorComponent_140_3.check_error(currVal_140_0_0,throwOnChange,false);
    const currVal_140_0_1:any = 'feeSelector';
    this._SaraSelectorComponent_140_3.check_name(currVal_140_0_1,throwOnChange,false);
    const currVal_140_0_2:any = ((this.context.posSelector == null)? (null as any): this.context.posSelector.config);
    this._SaraSelectorComponent_140_3.check_config(currVal_140_0_2,throwOnChange,false);
    const currVal_140_0_3:any = ((this.context.posSelector == null)? (null as any): this.context.posSelector.items);
    this._SaraSelectorComponent_140_3.check_items(currVal_140_0_3,throwOnChange,false);
    const currVal_140_0_4:any = ((this.context.posSelector == null)? (null as any): this.context.posSelector.validations);
    this._SaraSelectorComponent_140_3.check_validations(currVal_140_0_4,throwOnChange,false);
    const currVal_140_0_5:any = true;
    this._SaraSelectorComponent_140_3.check_editable(currVal_140_0_5,throwOnChange,false);
    this._SaraSelectorComponent_140_3.ngDoCheck(this,this._el_140,throwOnChange);
    const currVal_145_0_0:any = this._map_245('fees.ADDITIONALS');
    this._FormCardComponent_145_3.check_message(currVal_145_0_0,throwOnChange,false);
    this._FormCardComponent_145_3.ngDoCheck(this,this._el_145,throwOnChange);
    const currVal_149_0_0:any = this.context.errors['feeSelector'];
    this._SaraSelectorComponent_149_3.check_error(currVal_149_0_0,throwOnChange,false);
    const currVal_149_0_1:any = 'feeSelector';
    this._SaraSelectorComponent_149_3.check_name(currVal_149_0_1,throwOnChange,false);
    const currVal_149_0_2:any = ((this.context.posAddSelector == null)? (null as any): this.context.posAddSelector.config);
    this._SaraSelectorComponent_149_3.check_config(currVal_149_0_2,throwOnChange,false);
    const currVal_149_0_3:any = ((this.context.posAddSelector == null)? (null as any): this.context.posAddSelector.items);
    this._SaraSelectorComponent_149_3.check_items(currVal_149_0_3,throwOnChange,false);
    const currVal_149_0_4:any = ((this.context.posAddSelector == null)? (null as any): this.context.posAddSelector.validations);
    this._SaraSelectorComponent_149_3.check_validations(currVal_149_0_4,throwOnChange,false);
    const currVal_149_0_5:any = true;
    this._SaraSelectorComponent_149_3.check_editable(currVal_149_0_5,throwOnChange,false);
    this._SaraSelectorComponent_149_3.ngDoCheck(this,this._el_149,throwOnChange);
    const currVal_159_0_0:boolean = !this.context.savingPickupPointFee;
    this._NgIf_159_6.check_ngIf(currVal_159_0_0,throwOnChange,false);
    this._NgIf_159_6.ngDoCheck(this,this._anchor_159,throwOnChange);
    const currVal_161_0_0:any = this.context.savingPickupPointFee;
    this._NgIf_161_6.check_ngIf(currVal_161_0_0,throwOnChange,false);
    this._NgIf_161_6.ngDoCheck(this,this._anchor_161,throwOnChange);
    const currVal_163_0_0:any = this.context.cancelButton;
    this._EvaButtonComponent_163_3.check_button(currVal_163_0_0,throwOnChange,false);
    this._EvaButtonComponent_163_3.ngDoCheck(this,this._el_163,throwOnChange);
    this._vc_40.detectChangesInNestedViews(throwOnChange);
    this._vc_67.detectChangesInNestedViews(throwOnChange);
    this._vc_71.detectChangesInNestedViews(throwOnChange);
    this._vc_74.detectChangesInNestedViews(throwOnChange);
    this._vc_86.detectChangesInNestedViews(throwOnChange);
    this._vc_130.detectChangesInNestedViews(throwOnChange);
    this._vc_159.detectChangesInNestedViews(throwOnChange);
    this._vc_161.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_224:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('fees.TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_224,currVal_224))) {
      this.renderer.setText(this._text_17,currVal_224);
      this._expr_224 = currVal_224;
    }
    this._NgControlStatusGroup_27_5.checkHost(this,this,this._el_27,throwOnChange);
    valUnwrapper.reset();
    const currVal_226:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('fees.CATEGORY')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_226,currVal_226))) {
      this.renderer.setText(this._text_36,currVal_226);
      this._expr_226 = currVal_226;
    }
    valUnwrapper.reset();
    const currVal_228:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('fees.FEEIDENTIFIER.lang')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_228,currVal_228))) {
      this.renderer.setText(this._text_52,currVal_228);
      this._expr_228 = currVal_228;
    }
    valUnwrapper.reset();
    const currVal_231:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('fees.FEEIDENTIFIER.identifier')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_231,currVal_231))) {
      this.renderer.setText(this._text_61,currVal_231);
      this._expr_231 = currVal_231;
    }
    valUnwrapper.reset();
    const currVal_234:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('fees.TYPE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_234,currVal_234))) {
      this.renderer.setText(this._text_82,currVal_234);
      this._expr_234 = currVal_234;
    }
    const currVal_238:any = (this.context.fee.amountType != 'PERCENTAGE');
    if (import3.checkBinding(throwOnChange,this._expr_238,currVal_238)) {
      this.renderer.setElementProperty(this._el_104,'hidden',currVal_238);
      this._expr_238 = currVal_238;
    }
    const currVal_239:any = (this.context.fee.amountType != 'FIXED');
    if (import3.checkBinding(throwOnChange,this._expr_239,currVal_239)) {
      this.renderer.setElementProperty(this._el_107,'hidden',currVal_239);
      this._expr_239 = currVal_239;
    }
    const currVal_240:any = import3.inlineInterpolate(1,'',this.context.getCurrencyCode(),'');
    if (import3.checkBinding(throwOnChange,this._expr_240,currVal_240)) {
      this.renderer.setText(this._text_108,currVal_240);
      this._expr_240 = currVal_240;
    }
    valUnwrapper.reset();
    const currVal_242:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('fees.APPLY_TO')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_242,currVal_242))) {
      this.renderer.setText(this._text_126,currVal_242);
      this._expr_242 = currVal_242;
    }
    const currVal_246:boolean = !this.context.showActionButtons();
    if (import3.checkBinding(throwOnChange,this._expr_246,currVal_246)) {
      this.renderer.setElementProperty(this._el_155,'hidden',currVal_246);
      this._expr_246 = currVal_246;
    }
    this.compView_29.internalDetectChanges(throwOnChange);
    this.compView_54.internalDetectChanges(throwOnChange);
    this.compView_63.internalDetectChanges(throwOnChange);
    this.compView_92.internalDetectChanges(throwOnChange);
    this.compView_98.internalDetectChanges(throwOnChange);
    this.compView_116.internalDetectChanges(throwOnChange);
    this.compView_136.internalDetectChanges(throwOnChange);
    this.compView_140.internalDetectChanges(throwOnChange);
    this.compView_145.internalDetectChanges(throwOnChange);
    this.compView_149.internalDetectChanges(throwOnChange);
    this.compView_163.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_40.destroyNestedViews();
    this._vc_67.destroyNestedViews();
    this._vc_71.destroyNestedViews();
    this._vc_74.destroyNestedViews();
    this._vc_86.destroyNestedViews();
    this._vc_130.destroyNestedViews();
    this._vc_159.destroyNestedViews();
    this._vc_161.destroyNestedViews();
    this.compView_29.destroy();
    this.compView_54.destroy();
    this.compView_63.destroy();
    this.compView_92.destroy();
    this.compView_98.destroy();
    this.compView_116.destroy();
    this.compView_136.destroy();
    this.compView_140.destroy();
    this.compView_145.destroy();
    this.compView_149.destroy();
    this.compView_163.destroy();
    this._SaraSelectComponent_54_3.ngOnDestroy();
    this._SaraSelectComponent_63_3.ngOnDestroy();
    this._SaraInputA2Component_98_3.ngOnDestroy();
    this._SaraSelectComponent_116_3.ngOnDestroy();
    this._EvaButtonComponent_163_3.ngOnDestroy();
    this._NgForm_27_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
  }
  visitProjectableNodesInternal(nodeIndex:number,ngContentIndex:number,cb:any,ctx:any):void {
    if (((nodeIndex == 29) && (ngContentIndex == 0))) {
      cb(this._text_30,ctx);
      cb(this._el_31,ctx);
      cb(this._text_44,ctx);
      cb(this._el_45,ctx);
      cb(this._text_70,ctx);
      cb(this._vc_71.nativeElement,ctx);
      this._vc_71.visitNestedViewRootNodes(cb,ctx);
      cb(this._text_72,ctx);
      cb(this._text_73,ctx);
      cb(this._vc_74.nativeElement,ctx);
      this._vc_74.visitNestedViewRootNodes(cb,ctx);
      cb(this._text_75,ctx);
      cb(this._text_76,ctx);
      cb(this._el_77,ctx);
      cb(this._text_90,ctx);
    }
    if (((nodeIndex == 92) && (ngContentIndex == 0))) {
      cb(this._text_93,ctx);
      cb(this._el_94,ctx);
      cb(this._text_111,ctx);
      cb(this._el_112,ctx);
      cb(this._text_120,ctx);
      cb(this._el_121,ctx);
      cb(this._text_134,ctx);
    }
    if (((nodeIndex == 136) && (ngContentIndex == 0))) {
      cb(this._text_137,ctx);
      cb(this._el_138,ctx);
      cb(this._text_143,ctx);
    }
    if (((nodeIndex == 145) && (ngContentIndex == 0))) {
      cb(this._text_146,ctx);
      cb(this._el_147,ctx);
      cb(this._text_152,ctx);
    }
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 40)) { return new View_PickupPointFeeEditComponent1(this.viewUtils,this,40,this._anchor_40,this._vc_40); }
    if ((nodeIndex == 67)) { return new View_PickupPointFeeEditComponent2(this.viewUtils,this,67,this._anchor_67,this._vc_67); }
    if ((nodeIndex == 71)) { return new View_PickupPointFeeEditComponent3(this.viewUtils,this,71,this._anchor_71,this._vc_71); }
    if ((nodeIndex == 74)) { return new View_PickupPointFeeEditComponent4(this.viewUtils,this,74,this._anchor_74,this._vc_74); }
    if ((nodeIndex == 86)) { return new View_PickupPointFeeEditComponent7(this.viewUtils,this,86,this._anchor_86,this._vc_86); }
    if ((nodeIndex == 130)) { return new View_PickupPointFeeEditComponent8(this.viewUtils,this,130,this._anchor_130,this._vc_130); }
    if ((nodeIndex == 159)) { return new View_PickupPointFeeEditComponent9(this.viewUtils,this,159,this._anchor_159,this._vc_159); }
    if ((nodeIndex == 161)) { return new View_PickupPointFeeEditComponent10(this.viewUtils,this,161,this._anchor_161,this._vc_161); }
    return (null as any);
  }
  handleEvent_27(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._NgForm_27_3.handleEvent(eventName,$event) && result);
    return result;
  }
  handleEvent_54(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.feeIdentifierLangId = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'modelChange')) {
      const pd_sub_1:any = ((<any>this.context.changeFeeIdentifierLang($event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_63(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.feeIdentifierOid = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_98(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.fee.amount = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_116(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.fee.paymentType = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_163(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'action')) {
      const pd_sub_0:any = ((<any>this.context.cancel()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/pickuppointfee/edit/pickup-point-fee-edit.component.ngfactory.ts